<div class="panel-container">
    <div class="panel-title-wrapper">
        <div class="panel-title">
            {{ 'version-history.panel.FCU.title' | translate }}
        </div>
    </div>
    <div class="change-container">
        <div class="count-subtitle">
            {{ 'version-history.panel.FCU.count' | translate }}
        </div>
        <ng-container *ngIf="changes">
            <div class="change">
                <div>"{{ changes.old }}"</div>
                <mat-icon svgIcon="arrow-right" class="arrow-icon" />
                <div>"{{ changes.new }}"</div>
            </div>
        </ng-container>
        <ng-container *ngIf="numberFcu || numberFcu == 0">
            <div class="change">
                <div>"{{ numberFcu }}"</div>
            </div>
        </ng-container>
    </div>
</div>
